import { lazyLoad } from "utils/loadable";

export const EmployerInternshipDetails = lazyLoad(
  () => import("./index"),
  (module) => module.EmployerInternDetails
);